<template>
    <v-layout>
      <v-flex>
      <v-card>
        <v-card-title>
          <h3 class="headline mb-0 admin-header">Users</h3>
          <v-btn text icon color="grey lighten-1" @click="refreshList"><v-icon>fas fa-sync</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="fal fa-search"
            placeholder="Search"
            single-line
            hide-details
            clearable>
          </v-text-field>
          <v-spacer></v-spacer>
          <v-flex xs3>
            <v-select label="Select roles" :items="allRoles" v-model="selectedRoles" multiple clearable
            small-chips deletable-chips item-text="name" item-value="id"></v-select>
          </v-flex>
          <v-switch v-if="isSU && orgLockedLogins.length" v-model="lockedOnly" label="Locked only"
            color="error" hide-details class="mx-4 mt-0 pt-0"></v-switch>

          <v-dialog v-model="deletedUsersDialog" max-width="1000px">
            <deleted-users v-if="deletedUsersDialog" @userUnDeleted="refreshList" @usersUnDeleted="refreshList"></deleted-users>
          </v-dialog>
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn icon @click="deletedUsersDialog=true" v-on="on">
                <v-icon size=20 color="grey lighten-1">far fa-recycle</v-icon>
              </v-btn>
            </template>
            <span>Manage Recycle Bin</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isSU && orgLockedLogins.length">
            <template v-slot:activator="{on}">
              <v-btn icon @click="unlockOrgUsers" v-on="on" class="mx-2">
                <v-badge color="error" :content="orgLockedLogins.length">
                  <v-icon size=20 color="error">fas fa-lock-open</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Unlock all locked out users in this org</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isSU">
            <template v-slot:activator="{on}">
              <v-btn icon @click="unlockAllOrgs" v-on="on">
                <v-icon size=20 color="grey lighten-1">fas fa-unlock-alt</v-icon>
              </v-btn>
            </template>
            <span>Clear lockouts for all users on all orgs</span>
          </v-tooltip>

        </v-card-title>
        <v-dialog v-model="dialog" max-width="600px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">User</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="validUser" ref="userForm" @submit.prevent>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name *"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.email" :rules="[rules.formatEmail]" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.phone" :rules="[rules.formatPhone]" label="Phone"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      :autofocus="false"
                      autocomplete="off"
                      v-model="editedItem.timeZone"
                      :items="timeZEntries"
                      label="Timezone"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field autocomplete="new-password"
                    v-model="editedItem.login"  :rules="[rules.required, rules.formatLogin]"
                    label="Username *" >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-if="!(editedItem.id > 0)">
                    <v-checkbox label="Email User to Setup Password*" v-model="editedItem.sendPwdEmail"></v-checkbox>
                  </v-flex>
                  <v-flex v-if="!editedItem.sendPwdEmail && !(editedItem.id > 0)" xs12 sm12 md12>
                    <PasswordEntry @password-updated="updateCreateUserPassword"></PasswordEntry>
                  </v-flex>
                  <v-flex xs12 sm6 md6 v-if="isSU">
                    <v-checkbox label="Collection Agent?" v-model="editedItem.collectionAgent"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-select
                        :items="allRoles"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.roles"
                        :menu-props="{ maxHeight: '400' }"
                        label="Roles"
                        multiple
                      ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-select
                        :items="accessGroups"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.accessGroups"
                        :menu-props="{ maxHeight: '400' }"
                        label="Monitoring Groups"
                        multiple
                        disabled
                        hint="Monitoring Groups can be edited from the AccessGroups view"
                        persistent-hint
                      ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <i>Passwords can be updated using the <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-lock-alt</v-icon> icon in Users list</i>
              <v-spacer></v-spacer>
              <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">Cancel</v-btn>
              <v-btn color="primary" rounded  :disabled="!validUser || (!(editedItem.id > 0) && (!editedItem.sendPwdEmail && !editedItem.password))" @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <unlock-dialog ref="unlockDialog"></unlock-dialog>
        <v-dialog v-model="pwdChangeDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Update User Password</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="pwdForm" @submit.prevent>
              <v-text-field v-model="newLogin" autocomplete="off" :rules="[rules.required, rules.formatLogin]" label="Username"></v-text-field>

<!--              todo v-if !gov-->
              <v-checkbox label="Email User to Setup Password*" v-model="sendPwdEmail"></v-checkbox>

              <PasswordEntry v-if="!sendPwdEmail" @password-updated="updatePassword"></PasswordEntry>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="primary" outlined rounded  @click.native="closePasswordDialog">Cancel</v-btn>
            <v-btn color="primary" rounded  :disabled="!validPwd" @click.native="savePassword">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <v-data-table
          :options.sync="pagination"
          :headers="headers"
          :items="filteredUsers"
          :search="search"
          :loading="loading"
          :item-class="rowClass"
          class="elevation-1"
        >
          <template v-slot:item.id="{item}">
            <td v-if="isProfessional || isSU">{{ item.id }}</td>
          </template>
          <template v-slot:item.name="{item}">
            <td>
              <router-link to="" @click.native="editItem(item)">{{ item.name }}</router-link>
              &nbsp;
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-icon small v-if="item.collectionAgent" v-on="on">fas fa-folder fa-fw</v-icon>
                </template>
                <span>Collection Agent</span>
              </v-tooltip>
              <v-tooltip bottom v-if="isLocked(item)">
                <template v-slot:activator="{on}">
                  <v-chip x-small label color="error" class="ml-1" v-on="on">
                    <v-icon x-small left>fas fa-lock</v-icon>Locked
                  </v-chip>
                </template>
                <span>
                  Locked out after {{ lockout(item).attempts }} failed logins. Unlocks at {{ formatDateTime(lockout(item).lockedUntil) }}
                  <template v-if="lockout(item).linkedIps && lockout(item).linkedIps.length">
                    <br/>Unlocking will also unlock {{ lockout(item).linkedIps.join(', ') }}
                  </template>
                </span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:item.roles="{item}">
            <td>{{ formatRoles(item.roles) }}</td>
          </template>
          <template v-slot:item.updatedDate="{item}">
            <td>{{ formatDateTime(item.updatedDate) }}</td>
          </template>
          <template v-slot:item.actions="{item}">
            <td class="actions">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="editItem(item)"
                  v-on="on"
                  style="height: 0px; width: 0px; padding-right:2px;">
                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!item.isExternal">
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="changePassword(item)"
                         v-on="on"
                  style="height: 0px; width: 0px; padding-right:2px;">
                    <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-lock-alt fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Change Password</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="deleteUser(item)"
                    v-on="on"
                    style="height: 0px; width: 0px;"
                  >
                      <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
              <v-tooltip bottom v-if="canLaunchModule(item.login)">
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="launchModule(item, 'monitoring')"
                      v-on="on"
                      style="height: 0px; width: 0px;"
                  >
                    <v-icon color="grey lighten-1" style="font-size: 18px;">far fa-chart-line fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Launch CPM Monitoring</span>
              </v-tooltip>
              <v-tooltip bottom v-if="canLaunchModule(item.login)">
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="launchModule(item, 'historical2')"
                    v-on="on"
                    style="height: 0px; width: 0px;">
                      <v-icon color="grey lighten-1" style="font-size: 18px;">far fa-chart-bar fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Launch CPM Analytics</span>
              </v-tooltip>
              <v-tooltip bottom v-if="canLaunchModule(item.login)" >
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="launchModule(item, 'rooms')"
                    v-on="on"
                    style="height: 0px; width: 0px;"
                  >
                    <v-icon color="grey lighten-1" style="font-size: 18px;">far fa-map-marked-alt fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Launch Workspace Insights</span>
              </v-tooltip>
              <v-tooltip bottom v-if="isLocked(item)">
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="unlockUser(item)"
                         v-on="on"
                         style="height: 0px; width: 0px;"
                  >
                    <v-icon color="error" style="font-size: 18px;">fas fa-lock-open fa-fw</v-icon>
                  </v-btn>
                </template>
                <span>Unlock User</span>
              </v-tooltip>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" type="warning">
              Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
          <v-card-actions>
            <button class="btn btn-primary" @click="newItem()">New User</button>
          </v-card-actions>
      </v-card>
      </v-flex>
    </v-layout>
</template>
<script>
import moment from 'moment';
import {TZ_DISPLAY_MAP_USERS} from '../../models/timezone.model';
import _ from 'lodash';
import ConfigService from '../../../../services/config.service';
import DeletedUsers from './DeletedUsers.vue'
import UnlockDialog from './UnlockDialog.vue'
import { mapState, mapActions, mapGetters } from 'vuex';
import PasswordEntry from '../../../../components/password-setup-view/PasswordEntry.component.vue';

export default {
    components: {
      'deleted-users': DeletedUsers,
      'unlock-dialog': UnlockDialog,
      PasswordEntry
    },
    data(){
      return {
        timeZEntries: Object.entries(TZ_DISPLAY_MAP_USERS).map((a,b) => {return {text:a[1], value:a[0]}}),
        deletedUsersDialog: false,
        selectedRoles:[],
        lockedOnly: false,
        search: '',
        dialog: false,
        showErrDetails: false,
        newLogin: '',
        newPassword: '',
        sendPwdEmail: true,
        editedItem: {
          id: -1,
          name: '',
          login: '',
          password: '',
          collectionAgent: false,
          accessGroups: [],
          roles: [],
          isExternal: false,
          sendPwdEmail: true,
          timeZone: ''
        },
        defaultItem: {
          id: -1,
          name: '',
          login: '',
          password: '',
          collectionAgent: false,
          accessGroups: [],
          roles: [],
          isExternal: false,
          sendPwdEmail: true,
          timeZone: ''
        },
        editedId: -1,
        loading: false,
        pwdChangeDialog: false,
        confirmPassword: '',
        confirmPasswordCuForm: '',
        validUser: false,
        rules: {
          required: value => !!value || 'Required.',
          formatLogin: value => this.validateLoginFormat(value),
          formatEmail: value => !value || this.validateEmailFormat(value),
          formatPhone: value => !value || this.validatePhoneFormat(value),
        },
        selectedUserRoles: [],
        // lowercased login -> lockout from the auth-service brute force detector
        lockedLogins: {}
      }
  },

    computed: {
    ...mapGetters('user', {
        orgContext: 'getOrgContext',
        orgDomain: 'getOrgDomain',
        isProfessional: 'isProfessional',
        isSU: 'isSU',
        isSUPro: 'isSUPro',
        allUsers: 'activeUsers',
        allRoles: 'getUserPrivilegesAndCustomRoles',
        paginationStore: 'getPagination'
    }),
    ...mapGetters('endpoints', {
        accessGroups: 'accessGroups'
    }),
    filteredUsers: {
      get() {
        if (!this.allUsers) {
          return this.allUsers
        }
        let finalList = this.isSU ? this.allUsers : _.filter(this.allUsers, (usr) => { return !usr.login.includes('∞') })
        if (this.lockedOnly) {
          finalList = _.filter(finalList, (usr) => this.isLocked(usr))
        }
        if (!_.isEmpty(this.selectedRoles)) {
          finalList = _.filter(finalList, (usr) => {
            let roleids = !usr.roles ? [] : _.map(usr.roles, 'id')
            return !_.isEmpty(_.intersection(this.selectedRoles, roleids))
          })
        }
        return finalList
      }
    },
    pagination: {
      get() {
        return this.paginationStore
      },
      set(val) {
        if (val.stored) {
          this.$store.dispatch('user/setPagination', val)
        }
      },
    },
    headers: function() { return [
        {text: 'Name', align: 'left', sortable: true, value: 'name'},
        {text: 'Email', align: 'left', sortable: true, value: 'email'},
        {text: 'Phone', align: 'left', sortable: true, value: 'phone'},
        {text: 'Timezone', align: 'left', sortable: true, value: 'timeZone'},
        {text: 'Username', align: 'left', sortable: true, value: 'login'},
        {text: 'Roles', align: 'left', sortable: false, value: 'roles'},
        {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
        {text: 'Actions', align: 'left', sortable: false, value: 'actions', width: (this.isSUPro || this.isSU) ? "200px" : "125px"}
      ];
    },
    orgLockedLogins() {
      return _.chain(this.allUsers || [])
        .filter(usr => this.isLocked(usr))
        .map('login')
        .value()
    },
    validPwd: function() {
      return (this.sendPwdEmail || this.newPassword) && this.newLogin.length > 0;
    }
  },
  watch: {
    orgLockedLogins: function(val) {
      // the toggle is hidden once nobody is locked, so don't leave it filtering an empty list
      if (!val.length) {
        this.lockedOnly = false
      }
    },
    orgContext: async function(val) {

      this.loading = true
      await this.$store.dispatch('endpoints/getAllAccessGroups')
      await this.$store.dispatch('user/getAllUsers')
      this.$store.dispatch('user/getUserPrivilegesAndCustomRoles')
      this.loadLockouts()

      this.loading = false
    }
  },
  async created () {
    if (this.isProfessional || this.isSU) {
      this.headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }
    this.loading = true
    await this.$store.dispatch('user/getAllUsers')
    this.$store.dispatch('user/getUserPrivilegesAndCustomRoles')
    this.$store.dispatch('endpoints/getAllAccessGroups')
    this.loadLockouts()
    this.loading = false
  },
  methods: {
    async deleteUser(user) {
      if (confirm('Do you wish to delete ' + user.name + '? ')) {
        await this.$store.dispatch('user/deleteUser', user)
      }
    },
    changePassword(item) {

      if (item.isExternal) {
        alert("This user is being maintained with Single Sign On.  If you need to make adjustments to the user,  please reach out to your AD Administrator")
        return
      }

      this.editedItem = item
      this.newLogin = item.login
      this.newPassword = ''
      this.confirmPassword = ''
      this.sendPwdEmail = true
      this.pwdChangeDialog = true
    },
    closePasswordDialog() {
      this.pwdChangeDialog = false
      this.close()
    },
    async savePassword() {
      if (!this.$refs.pwdForm.validate()) {
        return
      }
      let success = await this.$store.dispatch('user/changePassword', { user: this.editedItem, newLogin: this.newLogin, newPassword: this.newPassword, sendPwdEmail: this.sendPwdEmail})
      if (success) {
        this.pwdChangeDialog = false
      }
    },
    async loadLockouts() {
      // the brute force cache is pre-login (username/IP) and not org-scoped, so this is su/suPro only
      if (!this.isSU) {
        return
      }
      const lockouts = await this.$store.dispatch('user/getLockedLogins')
      this.lockedLogins = _.keyBy(lockouts, l => l.key.toLowerCase())
    },
    lockout(user) {
      return user.login ? this.lockedLogins[user.login.toLowerCase()] : undefined
    },
    isLocked(user) {
      return !!this.lockout(user)
    },
    rowClass(item) {
      return this.isLocked(item) ? 'users-list-locked-row' : ''
    },
    async clearLockouts(usernames, reason) {
      const result = await this.$store.dispatch('user/clearLockouts', {usernames, reason})
      // IPs other usernames were also tried from are left locked by the auth-service
      if (result && !_.isEmpty(result.retainedIps) && await this.$refs.unlockDialog.open('IP Addresses Still Locked',
          'The following IP addresses are still locked because other usernames were also tried from them:\n\n'
          + result.retainedIps.join('\n') + '\n\nThis can indicate an attack. Unlock these IP addresses too?',
          {okText: 'Unlock IPs', showReason: false})) {
        await this.$store.dispatch('user/clearLockouts', {ips: result.retainedIps, reason})
      }
      this.loadLockouts()
    },
    async unlockUser(user) {
      const result = await this.$refs.unlockDialog.open('Unlock User', 'Do you wish to unlock ' + user.name + '?', {okText: 'Unlock'})
      if (result) {
        await this.clearLockouts([user.login], result.reason)
      }
    },
    async unlockOrgUsers() {
      const logins = this.orgLockedLogins
      const result = await this.$refs.unlockDialog.open('Unlock Users',
          'Do you wish to unlock all ' + logins.length + ' locked out user(s) in this org?', {okText: 'Unlock All'})
      if (result) {
        await this.clearLockouts(logins, result.reason)
      }
    },
    async unlockAllOrgs() {
      const result = await this.$refs.unlockDialog.open('Clear All Lockouts',
          'This will clear brute force lockouts for ALL users and IP addresses on ALL orgs. Continue?', {okText: 'Clear All'})
      if (result) {
        await this.$store.dispatch('user/clearAllLockoutsAllOrgs', result.reason)
        this.loadLockouts()
      }
    },
    async refreshList () {
      this.loading = true
      await this.$store.dispatch('user/getAllUsers')
      this.$store.dispatch('endpoints/getAllAccessGroups')
      this.loadLockouts()
      this.loading = false
    },
    formatAccessGroupsSummary(accessGroups) {
      if (!accessGroups || _.isEmpty(accessGroups)) {
        return ''
      }
      return _.head(accessGroups).name + ((accessGroups.length > 1) ? ' and ' + (accessGroups.length - 1) + ' more' : '')
    },
    formatAccessGroupsAll(accessGroups) {
      if (!accessGroups || _.isEmpty(accessGroups)) {
        return ''
      }
      return _.map(accessGroups, 'name').join(', ')
    },
    async editItem (item) {
        if (item.isExternal) {
          alert("This user is being maintained with Single Sign On.  If you need to make adjustments to the user,  please reach out to your AD Administrator")
          return
        }

        this.editedId = item.id
        this.selectedUserRoles = item.roles
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },
    newItem () {
      this.dialog = true
    },
    close() {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedId = -1
          this.confirmPasswordCuForm = ''
        }, 300)
    },
    async save () {
      if (!this.$refs.userForm.validate()) {
        return
      }
      this.editedItem.roles = this.editedItem.roles || []
      if ((this.editedItem.roles.length > 0) && (!_.has(this.editedItem.roles[0], 'id'))) {
        this.editedItem.roles = _.map(this.editedItem.roles, roleId => { return {
          id: roleId, name: (_.find(this.allRoles, {id: roleId}) || {}).name
          , code: (_.find(this.allRoles, {id: roleId}) || {}).code
          }})
      }

      let diff = _.differenceBy(this.editedItem.roles, this.allRoles, 'id')
      if (diff && diff.length) {
        if (!confirm('The following roles are not visible and will be removed from the user being edited: ' +
        _.map(diff, 'name').join()
        + '. Continue?')) {
          return
        } else {
          _.pullAllBy(this.editedItem.roles, diff, 'id')
        }
      }
      if (await this.$store.dispatch("user/addOrUpdateUser", this.editedItem)) {
        this.close()

        this.loading = true
        await this.$store.dispatch('user/getAllUsers')
        this.loading = false
      }
    },
    updatePassword(newPassword) {
      this.newPassword = newPassword;
    },
    updateCreateUserPassword(newPassword) {
      this.editedItem.password = newPassword;
    },
    validateLoginFormat(value) {
      let regexDomain = new RegExp('^((?!@).)*@' + this.orgDomain + '$','i')
      let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.isSU) {
        return regexDomain.test(value) || 'Format should match ...@' + this.orgDomain
      }
      return regexEmail.test(value) || 'Must be a valid username.'
    },
    validateEmailFormat(value) {
      let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regexEmail.test(value) || 'Must be a valid email'
    },
    validatePhoneFormat(value) {
      let regexEmail = /^[\+\(\s.\-\/\d\)]{5,30}$/
      return regexEmail.test(value) || 'Must be a valid phone number'
    },
    formatRoles(roles) {
      let filteredRoles = roles
      //if an org has module-access turned on, the custom-roles api will return __MOD roles as well
      //which is a good way to know if that feature is enabled on the org
      //if an org had the feature turned on and then later removed, the __MOD roles will still be in the custom-roles api response
      //so we need to filter them out here 
      const hasMod = _.find(this.allRoles, r => _.startsWith(r.code, '__MOD'))
      if (!hasMod) {
        filteredRoles = _.filter(roles, r => !_.startsWith(r.code, '__MOD'))
      }
      return _.map(filteredRoles, 'name').join(', ')
    },
    async launchModule(user, module) {
      let url = await this.$store.dispatch('user/buildModuleURL', {userId: user.id, login: user.login, module});
      
      var objActivity = {
        action: 'impersonation',
        appId: 'cpm-admin',
        view: this.$route.name,
        tab: '',
        url: window.location.href,
        source: 'UserList.vue',
        details: 'impersonating userId ' + user.id + ' (' + (user.login) + ')',
        data: JSON.stringify({userId: user.id, login: user.login})
      };
      await this.$store.dispatch('status/logActivity', objActivity);

      window.open(url);
    },
    formatDateTime(val) {
        return moment(val).format('MM/DD/YYYY, h:mm:ss a')
    },
    canLaunchModule(login) {
      return this.isSUPro || (login.includes('vyoptaadmin') && this.isSU)
    }
  }
}
</script>
<style>
  /* not scoped: data table rows are rendered by vuetify, outside this component's scope */
  /* !important: vuetify-overrides.scss resets the background of hovered rows */
  .v-data-table tbody tr.users-list-locked-row,
  .v-data-table tbody tr.users-list-locked-row:hover {
    background-color: rgba(244, 67, 54, 0.08) !important;
    box-shadow: inset 4px 0 0 #f44336;
  }
</style>
